// src/pages/MessageFilterPage.jsx
import React from 'react';
import FilterConfig from '../components/messages/FilterConfig';

function MessageFilterPage() {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">Message Filter Settings</h1>
          <p className="mt-1 text-sm text-gray-500">
            Configure automatic message filtering and moderation settings
          </p>
        </div>
      </div>
      <FilterConfig />
    </div>
  );
}

export default MessageFilterPage;